import {h, Component} from 'preact';
import {Field} from 'formik';
import cx from 'classnames';

import {Label, Hint, InputFeedback} from '../index';
import Icon from '@components/common/Icon';

export class TextField extends Component {

    componentDidMount () {
        if ( this.props.isFocused ) {
            setTimeout( () => this.field && this.field.focus(), 10 )
        }
    }

    componentDidUpdate () {
        if ( this.props.isFocused ) {
            this.field && this.field.focus();
        }
    }

    render ( {id, name, type = 'text', label, icon, iconClick, iconWrapperClasses, iconClassName, hint, error, errorShown, value, onChange, onBlur, className, inputClassName, children, ...props} ) {

        const groupClasses = cx(
            'input-group',
            className,
            {
                'animated shake error': !!error || !!errorShown
            }
        );

        const inputClasses = cx(
            'input-field',
            {'disabled': props.disabled},
            inputClassName
        );

        return (
            <div className={groupClasses}>
                {label &&
                <Label htmlFor={id} error={error}>
                    {label}
                </Label>
                }
                {hint &&
                <Hint htmlFor={id} error={error}>
                    {hint}
                </Hint>
                }
                {icon &&
                <Icon.ui wrapperClasses={iconWrapperClasses} onClick={iconClick} name={icon} className={iconClassName}/>
                }
                <Field
                    tabIndex={0}
                    innerRef={ref => this.field = ref}
                    type={type}
                    id={id}
                    name={name || id}
                    className={inputClasses}
                    onBlur={onBlur}
                    onChange={onChange}
                    value={value}
                    {...props}>
                    {children}
                </Field>
                <InputFeedback error={error}/>
            </div>
        );
    };
}
